import { z } from "zod";
/**
 * Строка `v_corp_links` (контракт v2.0 §4.2). `v_corp_client_links` — то же + `can_order`, `company_status`.
 */
export const zCorpLinkRowDto = z.object({
    link_id: z.string(),
    company_id: z.string(),
    // `corp_my_employees` (кабинет, TECH-CORP-008/CCR-038) этих колонок не отдаёт — аддитивно ослаблено до `.nullish()`.
    company_name: z.string().nullish(),
    client_id: z.string().nullish(),
    client_name: z.string().nullish(),
    phone_e164: z.string(),
    employee_label: z.string().nullish(),
    valid_from: z.string(),
    valid_to: z.string().nullish(),
    state: z.string(),
    is_blocked: z.boolean(),
    blocked_by_kind: z.string().nullish(),
    blocked_at: z.string().nullish(),
    block_reason: z.string().nullish(),
    ended_reason: z.string().nullish(),
    created_at: z.string(),
    created_by_kind: z.string().nullish(),
    orders_count: z.number(),
    last_order_at: z.string().nullish(),
    can_order: z.boolean().nullish(),
    company_status: z.string().nullish(),
});
/** Ответ `corp_link_add` (§4.3). */
export const zLinkAddResultDto = z.object({
    linkId: z.string(),
    state: z.string(),
    clientName: z.string().nullish(),
    phoneE164: z.string(),
    validFrom: z.string(),
    validTo: z.string().nullish(),
});
export const zLinkOpenOrderDto = z.object({
    orderId: z.string(),
    orderNumber: z.string().nullish(),
    scheduledDate: z.string().nullish(),
});
/** Ответ `corp_link_update` и `corp_link_set_blocked` (§4.3). */
export const zLinkChangeResultDto = z.object({
    linkId: z.string(),
    state: z.string(),
    validFrom: z.string(),
    validTo: z.string().nullish(),
    openOrders: z.array(zLinkOpenOrderDto).default([]),
});
